// src/components/InputField.tsx

import React from "react";

interface InputFieldProps {
  label: string;
  placeholder?: string;
  required?: boolean;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  placeholder,
  required,
  value,
  onChange,
  className,
}) => {
  return (
    // Add className prop to the div element if it is passed
    <div className={`mb-6 ${className}`}>
      <label className="text-base font-normal leading-[1.625rem]">
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>
      <input
        type="text"
        placeholder={placeholder}
        className="mt-2 h-[3.125rem] w-full min-w-[21.25rem] rounded-[0.625rem] border border-[#DCDCDC] p-3 text-base font-normal leading-[1.375rem] text-[#5E6D77]"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default InputField;
